module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item flex flex-cross-center",
    class: {
      checked: _vm.checked
    },
    on: {
      "click": _vm.click
    }
  }, [(_vm.selectable) ? _c('span', {
    staticClass: "checkbox"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "name flex-1"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('span', {
    staticClass: "amount flex-1"
  }, [_vm._v(_vm._s(_vm.item.amount))]), _vm._v(" "), _c('span', {
    staticClass: "flex-1 t-c"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.item.tag))])]), _vm._v(" "), _c('span', {
    staticClass: "date flex-1"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.item.date, 'yyyy-MM-dd')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10daf7a2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GiftItem.vue
// module id = 173
// module chunks = 15 16